import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { ClassEnrollmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

const ENROLLMENTS_PAGE_SIZE = 1000;
const STALE_TIME_MS = 5 * 60 * 1000;

export const useClassesEnrollmentsByStudentIdGet = (
  id: number,
  options?: { enabled?: boolean; refetchOnMount?: boolean },
) => {
  const accessToken = useAccessToken();
  const queryEnabled = options?.enabled ?? true;
  const refetchOnMount = options?.refetchOnMount ?? false;

  const { data, isError, isSuccess, isPending, refetch, isFetching } = useQuery({
    queryKey: [QueryKeys.ClassesEnrollmentsByStudentId, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
      return service.apiClassEnrollmentsStudentsIdGet({
        id,
        page: 1,
        pageSize: ENROLLMENTS_PAGE_SIZE,
      });
    },
    enabled: queryEnabled && !!accessToken && !!id && id > 0,
    staleTime: STALE_TIME_MS,
    refetchOnMount,
    refetchOnWindowFocus: refetchOnMount,
  });

  return {
    data,
    isError,
    isSuccess,
    isPending,
    refetch,
    isFetching,
  };
};
